<template>
  <div class="wrapper">
    <div class="inner" v-if="isShow">
      <div class="titlev">
        <div class="tabs-wrapper">
          <div
            v-for="(item, index) of tabList"
            :key="index"
            @click="clickSingle(item,index) "
            :class="['tab', tabSelectIndex === index ? 'tab-selected' : '']"
          >
            <div class="item-r">
              <div class="item-v">
                <span
                :class="['tabT', tabSelectItem === item ? 'tabT-selected' : '']">{{item}}</span>
                <div :class="['tabB', tabSelectItem === item ? 'tabB-selected' : '']"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-button"
            @click="clickBtn">更多
            <img src="@/assets/right-arrow-gray.png"
          alt=""
          class="right-arrow"/>
        </div>
      </div>
      <PeriodIncrease ref="PeriodIncrease" v-if="tabSelectItem === '资讯'" />
      <NetList ref="NetList" v-if="tabSelectItem === '公告'" />
    </div>
  </div>
</template>
<script>
import PeriodIncrease from '@/components/Fund-News.vue';
import NetList from '@/components/Fund-Announcement.vue';
import {
  detailPushPage,
} from '@/utils/nativeBridge';
import StoreManger from '@/utils/FundHQJHManger';

export default {
  name: 'market',
  components: {
    PeriodIncrease,
    NetList,
  },
  props: {},
  watch: {},
  data() {
    return {
      isShow: true,
      pageData: {},
      tabList: ['公告', '资讯'],
      tabSelectIndex: 0,
      tabSelectItem: '公告',
      nativeData: {},
      fundCode: '',
      fundType: '',
      pcData: {},
      rightButton: '我要发帖',
    };
  },
  computed: {
  },
  created() {
    this.handleDetail();
  },
  mounted() {},
  methods: {
    render() {
    },
    handleDetail() {
      this.handleData();
    },
    handleData() {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
    },
    clickSingle(item, index) {
      this.tabSelectItem = item;
      this.tabSelectIndex = index;
      if (index === 0) {
        // pz.gg.tab.click
        this.reportMonitor({
          eventName: 'pz.gg.tab.click',
        });
      } else {
        // pz.news.tab.click
        this.reportMonitor({
          eventName: 'pz.news.tab.click',
        });
      }
    },
    clickBtn() {
      if (this.tabSelectItem === '公告') {
        this.clickComment();
      } else {
        this.clickAsk();
      }
    },
    clickComment() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      detailPushPage({
        appId: '7be9fe8d23404e658637288726244df5',
        url: '/pages/optionalNews',
        params: {
          fundCode: this.fundCode,
          fundName: name,
          index: 2,
        },
      });
      this.reportMonitor({
        eventName: 'pz.xx.gg.more',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
    clickAsk() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      detailPushPage({
        appId: '7be9fe8d23404e658637288726244df5',
        url: '/pages/optionalNews',
        params: {
          fundCode: this.fundCode,
          fundName: name,
          index: 1,
        },
      });
      this.reportMonitor({
        eventName: 'pz.xx.news.more',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper{
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 24px;
  border-radius: 12px;
}
.inner {
  background-color: #ffffff;
  padding-bottom:6px;
  border-radius: 12px;
}
.titlev{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tabs-wrapper {
  display: flex;
  height: 88px;
  border-radius: 12px;
}
.tip-icon-t {
  height: 24px;
  width: 24px;
  margin-left: 10px;
  padding-bottom: 0px;
}
.tab {
  display: flex;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #333;
  letter-spacing: 0;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding-left: 24px;
  padding-right: 24px;
  margin-top: 30px;
}
.tab-selected {
  font-size: 36px;
  color: #000;
  font-weight: bold;
}
.tabT {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #333;
}
.tabT-selected {
  font-size: 36px;
  color: #000;
  font-weight: bold;
}
.tabB {
  position: relative;
  top: 10px;
  width: 30px;
  height: 6px;
  border-radius: 3px;
}
.tabB-selected {
  background-color:#ff4400;
}
.item-r{
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.item-v{
  position: relative;
  display: flex;
  flex: 1;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.right-button {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-radius: 29px;
  padding: 0px 20px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  width: 160px;
  z-index: 9;
  margin-top: 22px;
  line-height: normal;
}
.right-arrow {
    width: 32px;
    height: 32px;
  }
</style>
